import React from "react";
import MuiTableCell from "@mui/material/TableCell";
import { tableCellClasses as muiTableCellClasses } from "@mui/material/TableCell";
import PropTypes from "prop-types";

/**
 * TableCell component wrapper for table cells.
 * Wraps Material-UI TableCell with theme integration.
 * 
 * @component
 * @example
 * <TableCell>Cell content</TableCell>
 * <TableCell align="right">Numeric data</TableCell>
 */
const TableCell = ({ children, ...props }) => {
  return <MuiTableCell {...props}>{children}</MuiTableCell>;
};

/**
 * Export tableCellClasses for styling purposes
 * @example
 * import { tableCellClasses } from '../primitives';
 * sx={{ [`& .${tableCellClasses.root}`]: { borderBottom: 'none' } }}
 */
export const tableCellClasses = muiTableCellClasses;

TableCell.propTypes = {
  /**
   * The content of the component
   */
  children: PropTypes.node,
  /**
   * Set the text-align on the table cell content
   */
  align: PropTypes.oneOf(["left", "center", "right", "justify", "inherit"]),
  /**
   * The component used for the root node
   */
  component: PropTypes.elementType,
  /**
   * Sets the padding applied to the cell
   */
  padding: PropTypes.oneOf(["normal", "checkbox", "none"]),
  /**
   * Set scope attribute
   */
  scope: PropTypes.string,
  /**
   * Specify the size of the cell
   */
  size: PropTypes.oneOf(["small", "medium"]),
  /**
   * Set aria-sort direction
   */
  sortDirection: PropTypes.oneOf(["asc", "desc", false]),
  /**
   * Specify the cell type
   */
  variant: PropTypes.oneOf(["head", "body", "footer"]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles
   */
  sx: PropTypes.oneOfType([
    PropTypes.arrayOf(
      PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])
    ),
    PropTypes.func,
    PropTypes.object,
  ]),
};

// No defaultProps - maintain exact MUI TableCell behavior

export default TableCell;

